<template>
  <div class="dashboard-container">
    <img
      style="
        position: absolute;
        bottom: 0px;
        backgroud-color: #f2f5f5;
        opacity: 0.6;
      "
      src="@/assets/dashboard-bg.svg"
    />
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "Dashboard",
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-container {
  width: 100%;
  height: 100%;
  .welcome {
  }
}
.box-card {
  text-align: center;
  .value {
    font-size: 26px;
    margin: 20px auto;
    color: gray;
  }
  .title {
    font-size: 20px;
    color: black;
    font-weight: bold;
  }
  .subtitle {
    font-size: 12px;
    color: gray;
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  margin-bottom: 20px;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-weight: bold
}
</style>
